import * as React from 'react';
import { useSelector } from 'react-redux';

import { usePremiumBuilderProps } from './hooks';
import {
  NewbuildingPremiumBuilderLabel,
  NewbuildingPremiumBuilderLogo,
  NewbuildingPremiumBuilderLayout,
} from '../../../../components/AuthorAsideNew';
import { selectIsNewbuildingPremiumRate } from '../../../../selectors/newbuildingPremiumRate';

export const NewbuildingPremiumBuilderInfo: React.FC = () => {
  const isPremiumNewbuilding = useSelector(selectIsNewbuildingPremiumRate);

  const { builderProps, builderLabel, builderStats } = usePremiumBuilderProps();

  if (!isPremiumNewbuilding || !builderProps || !builderStats.length) {
    return null;
  }

  return (
    <NewbuildingPremiumBuilderLayout
      logo={<NewbuildingPremiumBuilderLogo {...builderProps} />}
      label={builderLabel ? <NewbuildingPremiumBuilderLabel /> : null}
      stats={builderStats}
    />
  );
};
